






















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Stage } from 'konva/types/Stage'
import { LineConfig } from 'konva/types/shapes/Line'

import Konva from 'konva'
Konva.pixelRatio = 1

@Component({
  components: {
    lines: () => import('./lines.vue')
  }
})
export default class Drawing extends Vue {
  $store!: ExStore

  get stage() {
    return (this.$refs.stage as any).getNode() as Stage
  }
  isMounted = false
  size = {
    width: 0,
    height: 0
  }
  isPaint = false
  lines: LineConfig[] = []
  lastLine: LineConfig = { points: [] }

  get disable() {
    return !this.$store.state.drawing.isDrawing
  }

  mounted() {
    this.size.width = window.innerWidth
    // headerの分だけ60px引く
    this.size.height = window.innerHeight - 60
    this.isMounted = true
  }

  get brush() {
    return this.$store.getters['drawing/brush']
  }

  drawStart(e: any) {
    if ('touches' in e && e.touches.length !== 1) return
    if (this.disable) return
    this.isPaint = true
    const pos = this.stage.getPointerPosition()
    if (!pos) return

    this.lastLine = {
      stroke: this.brush.color,
      strokeWidth: this.brush.lineWidth,
      globalCompositeOperation: this.brush.mode,
      opacity: this.brush.opacity,
      points: [pos.x, pos.y]
    }
    this.$store.commit('drawing/appendLine', this.lastLine)
    this.lines.push(this.lastLine)
    // this.backLines = []
  }

  draw(e: any) {
    if ('touches' in e && e.touches.length !== 1) return
    if (this.disable) return
    if (!this.isPaint) return
    const pos = this.stage.getPointerPosition()
    if (!pos) return
    this.lastLine.points = this.lastLine.points.concat([pos.x, pos.y])
  }

  drawEnd() {
    if (this.disable) return
    this.isPaint = false
    // this.afterDrawEnd()
  }
}
